import React from 'react';
import { CalendarClock, User } from 'lucide-react';
import { getSessionOptions } from '../utils/privateLesson';

/** Public class-card banner shown instead of the day/date/time schedule. */
export const PrivateLessonBanner = ({ program }) => {
  const options = getSessionOptions(program);
  return (
    <div
      className="mb-4 rounded-md border border-cafa-red/20 bg-cafa-red/5 px-3 py-2.5 space-y-1.5"
      data-testid={`private-lesson-banner-${program.id}`}
    >
      <div className="flex items-center gap-2 text-sm font-semibold text-stone-800">
        <User size={16} className="text-cafa-red flex-shrink-0" />
        <span>Private Lesson &middot; One-on-One</span>
      </div>
      <div className="flex items-start gap-2 text-sm text-stone-700">
        <CalendarClock size={16} className="text-cafa-red flex-shrink-0 mt-0.5" />
        <span>By appointment &mdash; you choose the time with your instructor</span>
      </div>
      <p className="text-sm text-stone-700 pl-6">
        {options.map(o => `${o.label} — $${o.price}`).join('  ·  ')}
      </p>
      {program.availability_note && (
        <p className="text-xs text-stone-500 pl-6">{program.availability_note}</p>
      )}
    </div>
  );
};
